<template>
  <div class="container">
    <div v-if="maxValue != 0" class="graph">
      <div class="bar" :style="{ width: barWidth + '%' }"></div>
    </div>
  </div>
</template>

<script>
import {
  separateCharacterNumber,
} from '@/common/util/format';
import { mapGetters } from 'vuex';

export default {
  name: 'GachaBarGraph',
  props: {
    maxValue: {
      type: [Number, String],
      default: 0,
    },
    currentValue: {
      type: [Number, String],
      default: 0,
    },
  },
  computed: {
    ...mapGetters({
      currentUser: 'user/currentUser',
    }),
    barWidth() {
      return (this.currentValue / this.maxValue) * 100 > 100 ? 100 : (this.currentValue / this.maxValue) * 100;
    },
  },
  filters: {
    comma(value) {
      return separateCharacterNumber(parseInt(value, 10));
    },
  },
};
</script>

<style lang="scss" scoped>
.container {
  text-align: center;
  font-family: Arial, sans-serif;
  padding: 0;
}
p {
  color: #FFF;
}
.graph {
  // width: 300px;
  height: 6px;
  border: 1px solid #FFF;
  margin: 0 auto;
  position: relative;
  background-color: #FFF;
  border-radius: 10px;
  border: 1px solid #6d6c6c;
  @media screen and (max-width: $tabletWidth) {
    width: auto;
    height: 6px;
  }
}
.bar {
  height: 100%;
  position: absolute;
  left: 0;
  border-radius: 10px;
  background: linear-gradient(to right, yellow, orange, red);
}
</style>
